/** An active device whose Device Telemetry is Manual gets the inductive print template. */

export interface PrintLetterDevice {
  status?: string | null;
  deviceTelemetry?: string | null;
}

function isActive(device: PrintLetterDevice): boolean {
  const status = String(device.status ?? '').toLowerCase();
  return !(status === 'inactive' || status === 'entered in error' || status === '0' || status === '4');
}

/** Device Telemetry is Wireless or Manual. Manual is the in-office inductive letter. */
function isManualTelemetry(value: string | null | undefined): boolean {
  const telemetry = String(value ?? '').trim().toLowerCase();
  return telemetry === 'manual' || telemetry === 'inductive';
}

export function usesInductivePrintLetter(
  devices: PrintLetterDevice[] | null | undefined
): boolean {
  return (devices ?? []).some((device) => isActive(device) && isManualTelemetry(device.deviceTelemetry));
}
